import React from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'antd';
import styles from './styles.module.css';

export function CheckboxField(props) {
  const { name, children, ...rest } = props;
  const [field, meta, helpers] = useField(name);
  const { t } = useTranslation();

  const { setValue, setTouched } = helpers;
  const { error, touched } = meta;
  const handleChange = () => {
    setValue(!field.value);
    setTouched(name, true);
  };

  const showError = touched && error;

  return (
    <div
      className={classNames(styles.checkbox, {
        [styles.checkbox_error]: error,
      })}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Checkbox {...rest} onChange={handleChange} checked={field.value}>
        {t(`field.${name}.label`)}
      </Checkbox>
      {showError && <span>{t(`error.${error}`)}</span>}
    </div>
  );
}
